export default __webpack_public_path__ + "static/media/add-to-apple-wallet-logo.1fcdc004.png";